import {
  AllowedRepeatingLesson,
  AllowedTravelTime,
} from "@hubcapp/components/Calendar/components/Modals/AddLessonModal/types";

export const travelTimeOptions: Record<AllowedTravelTime, string> = {
  0: "0 mins",
  15: "15 mins",
  30: "30 mins",
  45: "45 mins",
  60: "60 mins",
};

export const repeatingLessonOptions: Record<AllowedRepeatingLesson, any> = {
  NO_REPEAT: "No repeat",
  DAILY: "Daily",
  WEEKLY: "Weekly",
  MONTHLY: "Monthly",
};

export const repeatingLessonFrequencyNumberOptions = [
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
] as const;
